import React from "react";

interface TabsNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: {
    id: string;
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    count?: number;
  }[];
}

const TabsNavigation: React.FC<TabsNavigationProps> = ({
  activeTab,
  onTabChange,
  tabs,
}) => {
  return (
    <div className="card-wrap p-1! md:p-1! mb-6">
      {/* Mobile: Horizontal scrollable tabs */}
      <nav className="flex md:hidden overflow-x-auto scrollbar-hide space-x-1 pb-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex flex-col items-center justify-center min-w-[60px] px-2 py-2 rounded-md font-medium transition-all duration-200 whitespace-nowrap
                ${
                  isActive
                    ? "bg-blue-600 text-white shadow-md"
                    : "text-gray-400 hover:text-white hover:bg-gray-700"
                }
              `}
            >
              <Icon className="w-4 h-4 mb-1" />
              <span className="text-xs">{tab.label}</span>
              {tab.count !== undefined && (
                <span
                  className={`
                    mt-1 px-1.5 py-0.5 rounded-full text-[10px] font-semibold
                    ${
                      isActive
                        ? "bg-blue-500 text-white"
                        : "bg-gray-600 text-gray-300"
                    }
                  `}
                >
                  {tab.count}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Desktop: Horizontal tabs with text */}
      <nav className="hidden md:flex space-x-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center space-x-2 px-4 py-1 rounded-md font-medium transition-all duration-200
                ${
                  isActive
                    ? "bg-blue-600 text-white shadow-md"
                    : "text-gray-400 hover:text-white hover:bg-gray-700"
                }
              `}
            >
              <Icon className="w-5 h-5" />
              <span>{tab.label}</span>
              {tab.count !== undefined && (
                <span
                  className={`
                    ml-1 px-2 py-0.5 rounded-full text-xs font-semibold
                    ${
                      isActive
                        ? "bg-blue-500 text-white"
                        : "bg-gray-600 text-gray-300"
                    }
                  `}
                >
                  {tab.count}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default TabsNavigation;
